import React, { useEffect } from 'react';
import { Text } from '~/shared/components/Text/Text';
import { SummaryList } from '~/shared/components/Summary/components/SummaryList';
import styled from '@emotion/styled';
import { Product } from '~/lib/data-contract/salesforce';
import ChevronLeft from '~/icons/chevron-left.svg';

import { StyledBackButton, Title } from './styled';
import { format } from 'date-fns';

type ShipmentTypes = 'internal' | 'external';

type Props = {
    className?: string;
    products?: Product[];
    title?: string;
    subtitle: string;
    deliveryMessage?: string;
    info?: string;
    currentShipmentIndex?: number;
    shipmentType?: ShipmentTypes;
    onSelectDeliveryDate?: (value: string) => void;
    showPreviousShipment?: () => void;
};

export const SplitDeliverySummary = styled(
    ({
        info,
        className,
        products,
        title,
        subtitle,
        shipmentType,
        currentShipmentIndex,
        onSelectDeliveryDate,
        showPreviousShipment,
    }: Props) => {
        useEffect(() => {
            if (shipmentType === 'external' && onSelectDeliveryDate) {
                const date = format(new Date(), "yyyy-MM-dd'T'HH:mm:ss'Z");
                onSelectDeliveryDate && onSelectDeliveryDate(date);
            }
        }, [shipmentType]);
        return (
            <div className={className}>
                <Title style={{ display: 'flex', flexDirection: 'row' }}>
                    {currentShipmentIndex && currentShipmentIndex > 1 && (
                        <StyledBackButton
                            children={<ChevronLeft />}
                            onClick={showPreviousShipment}
                        />
                    )}
                    {title && <Text variant="display4">{title}</Text>}
                </Title>
                <Text variant="bodySmall">{subtitle}</Text>
                {<Text variant="bodySmall">{info}</Text>}
                <SummaryList large={true} hasBorder products={products} />
            </div>
        );
    },
)(({ theme }) => ({
    marginBottom: theme.space[3],
    [`${SummaryList}`]: {
        marginTop: theme.space[3],
    },
}));
